import { render, staticRenderFns } from "./VerMovimientosDetallado.vue?vue&type=template&id=1bd113a5&"
import script from "./VerMovimientosDetallado.vue?vue&type=script&lang=js&"
export * from "./VerMovimientosDetallado.vue?vue&type=script&lang=js&"
import style0 from "./VerMovimientosDetallado.vue?vue&type=style&index=0&id=1bd113a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports